// mindzera-frontend/src/SubscriptionsList.jsx
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './AuthContext.jsx';

export default function SubscriptionsList() {
  const { user, api, loading } = useAuth();
  const [subs,  setSubs]  = useState([]);
  const [error, setError] = useState('');

  /* Fetch once user is known */
  useEffect(() => {
    if (loading || !user) return;
    api.get(`/subscriptions?user_id=${user.id}`)
       .then(r => setSubs(r.data))
       .catch(e => setError(e.response?.data?.error || e.message));
  }, [loading, user]);

  if (loading) return <p className="text-center mt-10">Loading…</p>;
  if (error)   return <p className="text-red-600 text-center mt-10">{error}</p>;

  return (
    <main className="max-w-3xl mx-auto px-6 py-10">
      <h1 className="text-2xl font-bold mb-6">Your Subscriptions</h1>

      {subs.length === 0 ? (
        <p>No active subscriptions. <Link to="/subscribe" className="text-blue-600 underline">Choose a plan</Link>.</p>
      ) : (
        <ul className="space-y-4">
          {subs.map(s => (
            <li key={s.id} className="border p-4 rounded-lg shadow">
              Plan: <strong>{s.plan}</strong> • Status: {s.status} • Seats: {s.seats}
            </li>
          ))}
        </ul>
      )}
    </main>
  );
}
